module.exports = __webpack_public_path__ + "5dc8b6c690538bcb59e3d574ab364ac9.jpg";